import {
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  makeStyles,
} from '@material-ui/core';
import Button from 'components/Button/Button';
import DialogHeader from 'components/DialogHeader/DialogHeader';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setRecordAlreadyClockedInDialogOpen } from 'store/records/actions/records.actions';
import { selectPersonalClockedInWorkRecords } from 'store/records/selectors/records.selectors';
import { openClockOutRecordDialog } from 'store/records/thunks/openClockOutRecordDialog';

export const RecordAlreadyClockedInDialog = () => {
  const useStyles = makeStyles((theme) => ({
    dialogPaper: {
      ...theme.component.dialogPaper,
      [theme.breakpoints.down('xs')]: {
        ...theme.component.dialogPaperFullscreen,
      },
    },
    dialogContent: {
      paddingTop: theme.spacing(2),
    },
    dialogActions: {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
    },
    listAttribute: {
      marginBottom: '10px',
    },
  }));

  const { t } = useTranslation('common');

  const classes = useStyles();

  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(setRecordAlreadyClockedInDialogOpen(false));
  };

  const clockedInWorkRecords = useSelector(selectPersonalClockedInWorkRecords);

  const clockOutProjectId =
    clockedInWorkRecords[0].project.id || clockedInWorkRecords[0].project;

  return (
    <Dialog
      classes={{ paper: classes.dialogPaper }}
      fullWidth
      maxWidth="sm"
      open={true}
    >
      <DialogHeader
        title={t('project.record_already_clocked_in')}
        onClose={() => onClose()}
      />
      <DialogContent className={classes.dialogContent}>
        <p>{t('project.record_already_clocked_in_description')}</p>
      </DialogContent>
      <Divider />
      <DialogActions className={classes.dialogActions}>
        <Button
          elevated
          onClick={() => dispatch(openClockOutRecordDialog(clockOutProjectId))}
        >
          {t('project.go_to_clock_out')}
        </Button>
        <Button onClick={() => onClose()}>{t('common.close')}</Button>
      </DialogActions>
    </Dialog>
  );
};
